import React, { memo } from 'react';
import { useDrop } from 'react-dnd';
const DragWrapperContainer = /*#__PURE__*/memo(_ref => {
  let {
    children
  } = _ref;
  const [, drop] = useDrop(() => ({
    accept: 'TAB'
  }));
  return /*#__PURE__*/React.createElement("div", {
    ref: drop
  }, children);
});
export default DragWrapperContainer;